
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { Authenticate } from '../authenticate/authenticate';
import { Client, ClientCreate } from './client';
import { G } from '@angular/cdk/keycodes';

@Injectable({ providedIn: 'root' })
export class ClientService {
  auth: Authenticate;
  token = environment.token;
  clienturl = environment.appURL + "/clients";
  clientlighturl = environment.appURL + "/clients_light";
  constructor(private http: HttpClient) { }


  //  GENERAL API CALL TO GET CLIENTS
  getClients() { return this.http.get<Client[]>(this.clientlighturl, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getTicketes', []))); }


  //  GENERAL API CALL TO GET CLIENTS
  getClientsLightById(id: number) { return this.http.get<Client>(this.clientlighturl + "?id=" + id, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getTicketes', []))); }

  //  GET CLIENTS USING GRAPHQL
  getClientsQl() {
    var query = "{clients{id name address email phone_number contact_name}}";
    const url = environment.graphURL + query;
    return this.http.get<Client[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['clients']));
  }

  //  GET CLIENT BY CRITERIA VIA API CALL
  getClientByCriteria(criteria: string, argument: string) {
    const url = this.clienturl + "?" + criteria + "_contains=" + argument;
    return this.http.get<Client[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('geMachineByShortname', [])));
  }

  //  GET CLIENT BY ID VIA API CALL
  getClientById(id: number) {
    const url = `${environment.appURL}/clients_light?id=${id}`;
    return this.http.get<Client>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError<Client>(`client get id=${id}`)));
  }

  //  GET CLIENT BY ID USING GRAPHQL
  getClientByIdQl(id: number) {
    var query = "{client( id: " + id + "){id name address email machines{id serialnumber modelnumber shortname state{statevalue} location{id addr1 addr2 City Country}} locations{id addr1 addr2}}}";
    const url = environment.graphURL + query;
    return this.http.get<Client>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['client']));
  }

  //  GET CLIENT BY ID USING GRAPHQL
  getClientByIdQlLight(id: number) {
    var query = "{client( id: " + id + "){id name address email machines{id serialnumber modelnumber shortname state{statevalue} } }}";
    const url = environment.graphURL + query;
    return this.http.get<Client>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['client']));
  }

  // CREATE CLIENT FUNCTION VIA API CALL
  createClient(newclient: ClientCreate) {
    var upd = JSON.stringify(newclient);
    return this.http.post<Client>(`${environment.appURL}/clients/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  // UPDATE CLIENT 
    // UPDATE USER DETAILS
    update(client : Client) {
      var upd = JSON.stringify({
        address: client.address,
        email: client.email,
        contact_name: client.contact_name,
        phone_number: client.phone_number
      });
      var command = `${environment.appURL}/clients/` + client.id + "";
      return this.http.put(command, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }

  // ERROR HANDLING FOR API CALLS
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
